export const requests = {
  addParticipants: "ADD_PARTICIPANTS",
  assignMe: "ASSIGN_ME",
  loadGroupStatus: "LOAD_GROUP_STATUS",
  loadGroups: "LOAD_GROUPS",
  removeGroup: "REMOVE_GROUP",
  renameGroup: "RENAME_GROUP",
  renameParticipant: "RENAME_PARTICIPANT",
  deleteExpense: "DELETE_EXPENSE",
  deleteParticipant: "DELETE_PARTICIPANT",
  savePayment: "SAVE_PAYMENT",
  saveExpense: "SAVE_EXPENSE",
  saveTag: "SAVE_TAG",
  deleteTag: "DELETE_TAG",
  redeemTransferCode: "REDEEM_TRANSFER_CODE",
};

export const requestStates = {
  notSent: "NOT_SENT",
  sent: "SENT",
  error: "ERROR",
  success: "SUCCESS",
};
